import request from '@/utils/request'

export function getAuthorizationLink() {
  return request({
    url: '/api/authorize/page',
    method: 'get'
  })
}
// 小程序广告列表
export function appletsadvlist(params) {
  return request({
    url: '/officialAccount/getMiniProgramAdList',
    method: 'get',
    params
  })
}
// 小程序广告创建
export function creatappletsadvlist(data) {
  return request({
    url: '/officialAccount/createMiniProgramAd',
    method: 'post',
    data
  })
}
// 小程序广告修改
export function updateMiniProgramAd(data) {
  return request({
    url: '/officialAccount/updateMiniProgramAd',
    method: 'post',
    data
  })
}
// 小程序广告删除
export function delMiniProgramAd(data) {
  return request({
    url: '/officialAccount/delMiniProgramAd',
    method: 'post',
    data
  })
}
// 连续签到记录
export function usercachback(params) {
  return request({
    url: '/user/userCachback/list',
    method: 'get',
    params
  })
}
// 用户手动返现列表生成返现二维码
export function getqrcode(params) {
  return request({
    url: '/user/userCachback/getQrcode',
    method: 'get',
    params
  })
}

// 用户手动返现列表导出
export function exportListrw(params) {
  return request({
    url: '/user/userCachback/exportList',
    method: 'get',
    params
  })
}
// 私域销售列表
export function salerlistwe(params) {
  return request({
    url: '/user/saler/list',
    method: 'get',
    params
  })
}
// 私域销售新增
export function createdsawata(data) {
  return request({
    url: '/user/saler/createData',
    method: 'post',
    data
  })
}
// 私域销售更新
export function updateDatadaw(data) {
  return request({
    url: '/user/saler/updateData',
    method: 'post',
    data
  })
}
// 私域销售删除
export function deldaatadad(params) {
  return request({
    url: '/user/saler/delData',
    method: 'get',
    params
  })
}
// 用户绑定私域销售
export function privatedomainsales(data) {
  return request({
    url: '/user/bindSeller',
    method: 'post',
    data
  })
}
// 企业微信消息模板新增
export function spMessage(data) {
  return request({
    url: '/spWorkWechat/spMessage/create',
    method: 'post',
    data
  })
}
// 企业微信消息模板列表
export function spMessagelist(params) {
  return request({
    url: '/spWorkWechat/spMessage/list',
    method: 'get',
    params
  })
}
export function spMessagelistr(params) {
  return request({
    url: '/spWorkWechat/spChatGroup/index',
    method: 'get',
    params
  })
}
export function loaddown(params) {
  return request({
    url: '/spWorkWechat/spChatGroup/syncChatGroups',
    method: 'get',
    params
  })
}
export function syncChatGroupsByUser(params) {
  return request({
    url: '/spWorkWechat/spChatGroup/syncChatGroupsByUser',
    method: 'get',
    params
  })
}

// 企业微信消息模板更新
export function spMessagelistupdata(data) {
  return request({
    url: '/spWorkWechat/spMessage/update',
    method: 'post',
    data
  })
}

// 推送内部群消息到群机器人
export function sendToChatRobot(data) {
  return request({
    url: '/spWorkWechat/spMessage/sendToChatRobot',
    method: 'post',
    data
  })
}
// 企业微信的企业列表
export function spCorplist(params) {
  return request({
    url: '/spWorkWechat/spCorp/list',
    method: 'get',
    params
  })
}
// 企业微信的企业员工获取
export function spCorpfetchCorpUsers(params) {
  return request({
    url: '/spWorkWechat/spCorp/fetchCorpUsers',
    method: 'get',
    params
  })
}
// 部门列表详情
export function spCorpViewDepartmentUserList(params) {
  return request({
    url: `spWorkWechat/spCorp/departmentUserList`,
    method: 'get',
    params
  })
}
// 企业微信的企业员工列表
export function spCorpcorpUsersList(params) {
  return request({
    url: '/spWorkWechat/spCorp/corpUsersList',
    method: 'get',
    params
  })
}
// 拉取员工的外部客户
export function spCorpfetchExternalContacts(params) {
  return request({
    url: '/spWorkWechat/spCorp/fetchExternalContacts',
    method: 'get',
    params
  })
}
// 外部客户列表
export function spCorpexternalContactsList(params) {
  return request({
    url: '/spWorkWechat/spCorp/externalContactsList',
    method: 'get',
    params
  })
}
// 外部客户关联的企业成员列表
export function externalContactsList(params) {
  return request({
    url: '/spWorkWechat/spCorp/contactFollowUsers',
    method: 'get',
    params
  })
}
// 授权企微
export function authPage(params) {
  return request({
    url: '/spWorkWechat/spHandler/authPage',
    method: 'get',
    params
  })
}
export function supplierlist(params) {
  return request({
    url: '/spWorkWechat/spHandler/providerList',
    method: 'get',
    params
  })
}
// 企业微信策略列表
export function spMessagelisttactics(params) {
  return request({
    url: '/spWorkWechat/strategy/list',
    method: 'get',
    params
  })
}
// 企业微信策略保存
export function sprstrategystore(data) {
  return request({
    url: '/spWorkWechat/strategy/store',
    method: 'post',
    data
  })
}
// 企业微信策略详情
export function sprstrategystrategyInfo(params) {
  return request({
    url: '/spWorkWechat/strategy/strategyInfo',
    method: 'get',
    params
  })
}

// 企业微信策略编辑
export function sprstrategyupdate(data) {
  return request({
    url: '/spWorkWechat/strategy/update',
    method: 'post',
    timeout: 20 * 1000,
    data
  })
}
// 企业微信策略绑定员工的记录列表
export function sprbindRecords(params) {
  return request({
    url: '/spWorkWechat/strategyBind/bindRecords',
    method: 'get',
    params
  })
}
// 企业微信策略绑定员工
export function sprbindEmployeeNos(data) {
  return request({
    url: '/spWorkWechat/strategyBind/bindEmployeeNos',
    method: 'post',
    data
  })
}
// 企业微信策略解绑员工
export function sprremoveBind(data) {
  return request({
    url: '/spWorkWechat/strategyBind/removeBind',
    method: 'post',
    data
  })
}
// 为绑定策略的员工列表
export function sprcorpUsersForStrategy(params) {
  return request({
    url: '/spWorkWechat/spCorp/corpUsersForStrategy',
    method: 'get',
    params
  })
}
// 删除企微策略
export function sprdeletecover(data) {
  return request({
    url: '/spWorkWechat/strategy/deleteStrategy',
    method: 'post',
    data
  })
}
// 企微消息的详情
export function sprEnterprise(params) {
  return request({
    url: '/spWorkWechat/spMessage/messageInfo',
    method: 'get',
    params
  })
}
// 企微消息的详情
export function sprmessageInfo(params) {
  return request({
    url: '/ad1/userAction/getActionSourceIds',
    method: 'get',
    params
  })
}
// 上报配置新增
export function userActioncreate(data) {
  return request({
    url: '/ad1/userAction/create',
    method: 'post',
    data
  })
}
// 上报配置列表
export function userActionindex(params) {
  return request({
    url: '/ad1/userAction/index',
    method: 'get',
    params
  })
}
// 上报配置编辑
export function userActionupdate(data) {
  return request({
    url: '/ad1/userAction/update',
    method: 'post',
    data
  })
}
// 上报配置编辑
export function userActiondetail(params) {
  return request({
    url: '/ad1/userAction/detail',
    method: 'get',
    params
  })
}
// 企微策略发送记录
export function tacticssend(params) {
  return request({
    url: '/spWorkWechat/strategy/timingPushRecords',
    method: 'get',
    params
  })
}
// 企微策略发送记录导出
export function timingPushRecordsExport(params) {
  return request({
    url: '/spWorkWechat/strategy/timingPushRecordsExport',
    method: 'get',
    params
  })
}
// 企微定时推送列表详情
export function timingPushRecordDetails(params) {
  return request({
    url: '/spWorkWechat/strategy/timingPushRecordDetails',
    method: 'get',
    params
  })
}

// 企微消息删除
export function spdeleteMessage(params) {
  return request({
    url: '/spWorkWechat/spMessage/deleteMessage',
    method: 'get',
    params
  })
}
// 获取发送结果
export function spgetSentresult(data) {
  return request({
    url: '/spWorkWechat/strategy/getSentResult',
    method: 'post',
    data
  })
}
// 获取发送结果
export function remindCorpUserToSendMsg(params) {
  return request({
    url: '/spWorkWechat/strategy/remindCorpUserToSendMsg',
    method: 'get',
    params
  })
}
export function spgrounp(params) {
  return request({
    url: '/spWorkWechat/spChatGroup/employeeToGroups',
    method: 'get',
    params
  })
}

// 根据账户ID更新上传比例
export function updateRateByAccountId(data) {
  return request({
    url: '/ad1/userAction/updateRateByAccountId',
    method: 'post',
    data
  })
}

// 公众号个性化菜单列表
export function officialMenusgrounp(params) {
  return request({
    url: '/officialAccountMenu/officialMenus',
    method: 'get',
    params
  })
}
// 外部客户关联的企业成员列表
export function contactFollowUsers(params) {
  return request({
    url: '/spWorkWechat/spCorp/contactFollowUsers',
    method: 'get',
    params
  })
}

// 导入阅文企业微信客户
export function yueWenUserImport(data) {
  return request({
    url: '/spWorkWechat/spCorp/yueWenUserImport',
    method: 'post',
    data
  })
}

// 公众号菜单解绑
export function officialAccountMenuunbind(data) {
  return request({
    url: '/officialAccountMenu/unbind',
    method: 'post',
    data
  })
}

export function staffOfficialCreate(data) {
  return request({
    url: '/spWorkWechat/staffOfficial/create',

    method: 'post',
    data
  })
}

export function contactFollowUserslist(params) {
  return request({
    url: '/spWorkWechat/staffOfficial/index',
    method: 'get',
    params
  })
}
// 解绑
export function staffOfficialunBinding(data) {
  return request({
    url: '/spWorkWechat/staffOfficial/unBinding',
    method: 'post',
    data
  })
}
// 犹创第三方 获取登录二维码
export function getLoginQrcode(params) {
  return request({
    url: '/spWorkWechat/upTool/getLoginQrcode',
    method: 'get',
    timeout: 150 * 1000,
    params
  })
}
// 企业微信的企业员工列表
export function spCorpcorpUsersListband(params) {
  return request({
    url: '/spWorkWechat/staffOfficial/changeStaff',
    method: 'get',
    params
  })
}
// 修改管理员
export function editCorpUserAdmin(data) {
  return request({
    url: '/spWorkWechat/spCorp/editCorpUserAdmin',
    method: 'post',
    data
  })
}
// 设置员工标签
export function setCorpUserTag(data) {
  return request({
    url: '/spWorkWechat/spCorp/setCorpUserTag',
    method: 'post',
    data
  })
}
// 主动拉取全部客户
export function pullFriendList(data) {
  return request({
    url: '/spWorkWechat/upTool/pullFriendList',
    method: 'post',
    data
  })
}
// 获取员工企微好友（私聊界面）
export function getFriendList(params) {
  return request({
    url: '/spWorkWechat/upTool/getFriendList',
    method: 'get',
    params
  })
}
// 发送消息（私聊）
export function sendMessage(data) {
  return request({
    url: '/spWorkWechat/upTool/sendMessage',
    method: 'post',
    data
  })
}
// 获取可发送的小程序列表
export function miniprogramList(params) {
  return request({
    url: '/spWorkWechat/upTool/miniprogramList',
    method: 'get',
    params
  })
}
// 获取聊天记录
export function chatRecord(params) {
  return request({
    url: '/spWorkWechat/upTool/chatRecord',
    method: 'get',
    params
  })
}
// 第三方接口发送记录
export function thirdPartyPushRecords(params) {
  return request({
    url: '/spWorkWechat/strategy/thirdPartyPushRecords',
    method: 'get',
    params
  })
}
// 企微小程序列表
export function weComApplet(params) {
  return request({
    url: '/spWorkWechat/weComApplet/index',
    method: 'get',
    params
  })
}
// 发送消息（私聊）
export function unBinding(data) {
  return request({
    url: '/spWorkWechat/weComApplet/unBinding',
    method: 'post',
    data
  })
}
// 企业微信小程序关联
export function spCorplistband(data) {
  return request({
    url: '/spWorkWechat/weComApplet/create',
    method: 'post',
    data
  })
}
// 创建群聊
export function createChat(data) {
  return request({
    url: '/spWorkWechat/upTool/createChat',
    method: 'post',
    data
  })
}
// 删除企业微信-小程序绑定
export function delBinding(data) {
  return request({
    url: '/spWorkWechat/weComApplet/delBinding',
    method: 'post',
    data
  })
}
// 获取可加群好友列表
export function getCanInviteFriends(params) {
  return request({
    url: '/spWorkWechat/upTool/getCanInviteFriends',
    method: 'get',
    params
  })
}
// 获取可加群企业联系人列表
export function getCanInviteEmployees(params) {
  return request({
    url: '/spWorkWechat/upTool/getCanInviteEmployees',
    method: 'get',
    params
  })
}

// 邀请入群
export function invitationMemberToChat(data) {
  return request({
    url: '/spWorkWechat/upTool/invitationMemberToChat',
    method: 'post',
    data
  })
}

// 修改群名称
export function editCrowdname(data) {
  return request({
    url: '/spWorkWechat/upTool/changeChatName',
    method: 'post',
    data
  })
}
// 客户端列表
export function clientindex(params) {
  return request({
    url: '/spWorkWechat/upTool/client/index',
    method: 'get',
    params
  })
}
// 获取区域列表
export function clientareaList(params) {
  return request({
    url: '/spWorkWechat/upTool/client/areaList',
    method: 'get',
    params
  })
}
// 客户端添加
export function clientstore(data) {
  return request({
    url: '/spWorkWechat/upTool/client/store',
    method: 'post',
    data
  })
}
// 客户端更新
export function clientupdate(data) {
  return request({
    url: '/spWorkWechat/upTool/client/update',
    method: 'post',
    data
  })
}
// 客户端删除
export function clientdestroy(data) {
  return request({
    url: '/spWorkWechat/upTool/client/destroy',
    method: 'post',
    data
  })
}
// 绑定客户端
export function upToolbindClient(data) {
  return request({
    url: '/spWorkWechat/upTool/clientRelation/bind',
    method: 'post',
    data
  })
}
// 修改是否接收小程序
export function setReceiveMiniprogram(data) {
  return request({
    url: '/spWorkWechat/spCorp/setReceiveMiniprogram',
    method: 'post',
    data
  })
}
// 发言人列表
export function groupToEmployeeslist(params) {
  return request({
    url: '/spWorkWechat/spChatGroup/groupToEmployees',
    method: 'get',
    params
  })
}
// 设置发言人
export function setSpokesmanlist(data) {
  return request({
    url: '/spWorkWechat/spChatGroupExt/setSpokesman',
    method: 'post',
    data
  })
}
// 发言人列表1
export function groupToEmployeeslistr(params) {
  return request({
    url: '/spWorkWechat/groupChatSet/spokesmanList',
    method: 'get',
    params
  })
}
// 发言人列表3
export function getCorpColleaguesUnrestricted(params) {
  return request({
    url: '/spWorkWechat/groupChatSet/getCorpColleaguesUnrestricted',
    method: 'get',
    params
  })
}

// 拉群设置创建
export function groupChatSetcreate(data) {
  return request({
    url: '/spWorkWechat/groupChatSet/create',
    method: 'post',
    data
  })
}
// 拉群设置状态编辑
export function editAutomaticType(data) {
  return request({
    url: '/spWorkWechat/groupChatSet/editGroupChatSet',
    method: 'post',
    data
  })
}
// 拉群设置列表
export function groupChatSetindex(params) {
  return request({
    url: '/spWorkWechat/groupChatSet/index',
    method: 'get',
    params
  })
}
// 筛选已选择的群聊
export function changeGroupChat(params) {
  return request({
    url: '/spWorkWechat/strategyBind/changeGroupChat',
    method: 'get',
    params
  })
}

// 策略绑定群
export function bindGroupChats(data) {
  return request({
    url: '/spWorkWechat/strategyBind/bindGroupChats',
    method: 'post',
    timeout: 30 * 1000,
    data
  })
}
export function editAutomaticTypewe(data) {
  return request({
    url: '/spWorkWechat/groupChatSet/editAutomaticType',
    method: 'post',
    data
  })
}
// 企业微信策略解绑群
export function removeBind(data) {
  return request({
    url: '/spWorkWechat/strategyBind/removeBind',
    method: 'post',
    data
  })
}
// 开始拉群
export function startCreateChat(data) {
  return request({
    url: '/spWorkWechat/groupChatSet/startCreateChat',
    method: 'post',
    data
  })
}
// 开始拉人
export function startInvite(data) {
  return request({
    url: '/spWorkWechat/groupChatSet/startInvite',
    method: 'post',
    data
  })
}
// 临时群发列表
export function temporaryPushindex(params) {
  return request({
    url: '/spWorkWechat/temporaryPush/index',
    method: 'get',
    params
  })
}
// 临时群发详情
export function temporaryPushtimingPushInfo(params) {
  return request({
    url: '/spWorkWechat/temporaryPush/temporaryPushInfo',
    method: 'get',
    params
  })
}
// 临时群发新增
export function temporaryPushstore(data) {
  return request({
    url: '/spWorkWechat/temporaryPush/store',
    method: 'post',
    data
  })
}
// 临时群发编辑
export function temporaryPushupdate(data) {
  return request({
    url: '/spWorkWechat/temporaryPush/update',
    method: 'post',
    data
  })
}
// 临时群发删除
export function temporaryPushdelete(data) {
  return request({
    url: '/spWorkWechat/temporaryPush/delete',
    method: 'post',
    data
  })
}
// 临时群发停止
export function temporaryPushstopTemporaryPush(data) {
  return request({
    url: '/spWorkWechat/temporaryPush/stopTemporaryPush',
    method: 'post',
    data
  })
}
// 临时群发员工列表
export function temporaryPushcorpUsers(params) {
  return request({
    url: '/spWorkWechat/temporaryPush/corpUsers',
    method: 'get',
    params
  })
}
// 临时群发群聊列表
export function temporaryPushchangeGroupChat(params) {
  return request({
    url: '/spWorkWechat/temporaryPush/changeGroupChat',
    method: 'get',
    params
  })
}
// 临时群发绑定记录
export function temporaryPushbindList(params) {
  return request({
    url: '/spWorkWechat/temporaryPush/bindList',
    method: 'get',
    params
  })
}
// 临时群发解绑
export function temporaryPushunBinding(data) {
  return request({
    url: '/spWorkWechat/temporaryPush/unBinding',
    method: 'post',
    data
  })
}
// 临时推送记录
export function temporaryPushpushRecord(params) {
  return request({
    url: '/spWorkWechat/temporaryPush/pushRecord',
    method: 'get',
    params
  })
}
// 查看部门
export function spCorpViewDepartmentr(id) {
  return request({
    url: `/spWorkWechat/spCorp/departmentList?id=${id}`,
    method: 'get'
  })
}
// 选择拉人的人
export function getEmployeeNoFriend(params) {
  return request({
    url: '/spWorkWechat/groupChatSet/getEmployeeNoFriend',
    method: 'get',
    params
  })
}
// 更换群主
export function setGroupOwner(data) {
  return request({
    url: '/spWorkWechat/groupChatSet/setGroupOwner',
    method: 'post',
    data
  })
}
// 更换群主配置详情
export function configDetail(params) {
  return request({
    url: '/spWorkWechat/groupChatSet/configDetail',
    method: 'get',
    params
  })
}
// 外部联系人
export function groupChatSetgetCorpColleagues(params) {
  return request({
    url: '/spWorkWechat/groupChatSet/getCorpColleagues',
    method: 'get',
    params
  })
}
// 查看策略绑定
export function spCorpgetBindStrategy(params) {
  return request({
    url: '/spWorkWechat/spCorp/getBindStrategy',
    method: 'get',
    params
  })
}
// 群聊策略
export function pullGroupStrategy(params) {
  return request({
    url: '/spWorkWechat/spCorp/pullGroupStrategy',
    method: 'get',
    params
  })
}
// 设置已登录
export function setUpLogin(params) {
  return request({
    url: '/spWorkWechat/upTool/setLoginStatus',
    method: 'post',
    params
  })
}
// 设置企微号登录平台
export function setUpLoginPlatform(params) {
  return request({
    url: '/spWorkWechat/spCorp/setLoginPlatform',
    method: 'post',
    params
  })
}
// 员工群聊策略
export function getBindGroupStrategy(params) {
  return request({
    url: '/spWorkWechat/spCorp/getBindGroupStrategy',
    method: 'get',
    params
  })
}
// 解除策略绑定
export function spCorpremoveStrategy(data) {
  return request({
    url: '/spWorkWechat/spCorp/removeStrategy',
    method: 'post',
    data
  })
}
// 一键解绑
export function unBindEmpStrategy(data = {}) {
  return request({
    url: '/spWorkWechat/spCorp/unBindEmpStrategy',
    method: 'post',
    data
  })
}
// 登出
export function upToollogout(data) {
  return request({
    url: '/spWorkWechat/upTool/logout',
    method: 'post',
    data
  })
}
// 统计未发送的消息
export function messagePushUpindex(params) {
  return request({
    url: '/spWorkWechat/messagePushUp/index',
    method: 'get',
    params
  })
}
// 清除未发送消息
export function messagePushUpclear(params) {
  return request({
    url: '/spWorkWechat/messagePushUp/clear',
    method: 'get',
    params
  })
}
// 解封
export function Unblocklear(data) {
  return request({
    url: '/spWorkWechat/spCorp/disableStatus',
    method: 'post',
    data
  })
}
// 关键字投诉
export function keywordCollectindex(params) {
  return request({
    url: '/spWorkWechat/keywordCollect/index',
    method: 'get',
    params
  })
}
// 客户端绑定对应列表
export function upToolclientRelation(params) {
  return request({
    url: '/spWorkWechat/upTool/clientRelation/index',
    method: 'get',
    params
  })
}
// 编辑处理结果
export function editProcessingStatus(data) {
  return request({
    url: '/spWorkWechat/keywordCollect/editProcessingStatus',
    method: 'post',
    data
  })
}
export function spWorkWechatSpCorpInternalGroupPull(corp_id) {
  return request({
    url: '/spWorkWechat/spCorp/internalGroupPull',
    method: 'post',
    params: {
      corp_id
    }
  })
}
// 企微接口调用许可(订单列表)
export function accountAccessindex(params) {
  return request({
    url: '/spWorkWechat/accountAccess/index',
    method: 'get',
    params
  })
}
// 企微接口调用许可(服务商员工列表)
export function accountAccesslistProviderUsers(params) {
  return request({
    url: '/spWorkWechat/accountAccess/listProviderUsers',
    method: 'get',
    params
  })
}
// 企微接口调用许可(订单创建)
export function spaccountAccessindex(data) {
  return request({
    url: '/spWorkWechat/accountAccess/createOrder',
    method: 'post',
    data
  })
}
// 员工消息推送频率列表
export function frequencyindex(params) {
  return request({
    url: '/spWorkWechat/frequency/index',
    method: 'get',
    params
  })
}
// 筛选已绑定的员工推送频率
export function corpUsersListForFrequency(params) {
  return request({
    url: '/spWorkWechat/frequency/corpUsersListForFrequency',
    method: 'get',
    params
  })
}
// 获取消息频率模板
export function getFrequency(params) {
  return request({
    url: '/spWorkWechat/frequency/getFrequency',
    method: 'get',
    params
  })
}
// 创建员工消息推送频率
export function frequencystore(data) {
  return request({
    url: '/spWorkWechat/frequency/store',
    method: 'post',
    data
  })
}
// 编辑员工消息推送频率
export function frequencyupdate(data) {
  return request({
    url: '/spWorkWechat/frequency/update',
    method: 'post',
    data
  })
}
// 拉取订单详情
export function accountOrderDetail(params) {
  return request({
    url: '/spWorkWechat/accountAccess/accountOrderDetail',
    method: 'get',
    params
  })
}
// 取消订单
export function accountAccessdelOrder(data) {
  return request({
    url: '/spWorkWechat/accountAccess/delOrder',
    method: 'post',
    data
  })
}
// 订单账号列表拉取
export function listOrderAccount(data) {
  return request({
    url: '/spWorkWechat/accountAccess/listOrderAccount',
    method: 'post',
    data
  })
}
// 用户接口调用许可列表
export function userAccessList(params) {
  return request({
    url: '/spWorkWechat/accountAccess/userAccessList',
    method: 'get',
    params
  })
}
// 激活账号
export function activateUsers(data) {
  return request({
    url: '/spWorkWechat/accountAccess/activateUsers',
    method: 'post',
    data
  })
}
// 删除员工推送消息频率
export function frequencydelete(data) {
  return request({
    url: '/spWorkWechat/frequency/delete',
    method: 'post',
    data
  })
}
// 解绑客户端
export function upToolunbind(data) {
  return request({
    url: '/spWorkWechat/upTool/clientRelation/unbind',
    method: 'post',
    data
  })
}
// 创建积分消息推送频率
export function integralFrequencystore(data) {
  return request({
    url: '/spWorkWechat/integralFrequency/store',
    method: 'post',
    data
  })
}
// 设置转发飞书客服
export function bindFeiShuKf(data) {
  return request({
    url: '/spWorkWechat/upTool/bindFeiShuKf',
    method: 'post',
    data
  })
}
// 更新积分消息推送频率
export function integralFrequencyupdate(data) {
  return request({
    url: '/spWorkWechat/integralFrequency/update',
    method: 'post',
    data
  })
}
// 列表积分消息推送频率
export function integralFrequencyindex(params) {
  return request({
    url: '/spWorkWechat/integralFrequency/index',
    method: 'get',
    params
  })
}
// 删除积分消息推送频率
export function integralFrequencydelete(data) {
  return request({
    url: '/spWorkWechat/integralFrequency/delete',
    method: 'post',
    data
  })
}
export function getMultiTitles(data) {
  return request({
    url: '/spWorkWechat/spMessage/getMultiTitles',
    method: 'post',
    data
  })
}
// 修改企业管理员
export function editCorpAdmin(data) {
  return request({
    url: '/spWorkWechat/spCorp/editCorpAdmin',
    method: 'post',
    data
  })
}

// 关键字投诉后续记录
export function keywordCollectrecord(params) {
  return request({
    url: '/spWorkWechat/keywordCollect/record',
    method: 'get',
    params
  })
}
// 创建发布朋友圈任务(朋友圈列表)
export function momentsmomentsList(params) {
  return request({
    url: '/spWorkWechat/moments/momentsList',
    method: 'get',
    params
  })
}
// 创建发布朋友圈任务
export function momentsPushpushCreate(data) {
  return request({
    url: '/spWorkWechat/momentsPush/pushCreate',
    method: 'post',
    data
  })
}
// 编辑发布朋友圈任务
export function momentsPushPushUpdate(data) {
  return request({
    url: '/spWorkWechat/momentsPush/pushUpdate',
    method: 'post',
    data
  })
}
// 发布朋友圈任务列表
export function momentsPushpushList(params) {
  return request({
    url: '/spWorkWechat/momentsPush/pushList',
    method: 'get',
    params
  })
}
// 删除发布朋友圈任务
export function momentsPushpushDel(data) {
  return request({
    url: '/spWorkWechat/momentsPush/pushDel',
    method: 'post',
    data
  })
}
// 停止发布朋友圈任务
export function momentsPushpushStop(data) {
  return request({
    url: '/spWorkWechat/momentsPush/pushStop',
    method: 'post',
    data
  })
}
// 朋友圈任务详情
export function momentsPushpushDetail(params) {
  return request({
    url: '/spWorkWechat/momentsPush/pushDetail',
    method: 'get',
    params
  })
}
// 朋友圈任务绑定记录
export function momentsPushbindList(params) {
  return request({
    url: '/spWorkWechat/momentsPush/bindList',
    method: 'get',
    params
  })
}
// 朋友圈任务解绑
export function momentsPushunBinding(data) {
  return request({
    url: '/spWorkWechat/momentsPush/unBinding',
    method: 'post',
    data
  })
}
// 设置小程序发送人
export function setReceiveMiniprogramFriend(data) {
  return request({
    url: '/spWorkWechat/upTool/setReceiveMiniprogramFriend',
    method: 'post',
    data
  })
}
// 强制解除静置
export function upToolliftingBan(data) {
  return request({
    url: '/spWorkWechat/upTool/liftingBan',
    method: 'post',
    data
  })
}
// 修改小程序备注
export function updateByMpId(data) {
  return request({
    url: '/spWorkWechat/upTool/updateByMpId',
    method: 'post',
    data
  })
}
// 选择消息的验证
export function appletCheck(data) {
  return request({
    url: '/spWorkWechat/strategy/appletCheck',
    method: 'post',
    timeout: 25 * 1000,
    data
  })
}
// 选择消息的验证
export function appletCheckMessage(data) {
  return request({
    url: '/spWorkWechat/spMessage/appletCheck',
    method: 'post',
    timeout: 25 * 1000,
    data
  })
}
// 拉群进度
export function schedulelist(params) {
  return request({
    url: '/spWorkWechat/groupChatSet/schedule',
    method: 'get',
    params
  })
}
// 新增小程序
export function createMiniprogram(data) {
  return request({
    url: '/spWorkWechat/upTool/createMiniprogram',
    method: 'post',
    data
  })
}
// 小程序列表
export function repeatMiniprogramList(params) {
  return request({
    url: '/spWorkWechat/upTool/repeatMiniprogramList',
    method: 'get',
    params
  })
}
// 获取企业标签
export function corpTag(data) {
  return request({
    url: '/spWorkWechat/strategyBind/corpTag',
    method: 'post',
    data
  })
}
// 获取已绑定员工的企业标签
export function corpUseTag(data) {
  return request({
    url: '/spWorkWechat/strategyBind/corpUseTag',
    method: 'post',
    data
  })
}
// 修改已绑定的企业标签
export function updEmpTag(data) {
  return request({
    url: '/spWorkWechat/strategyBind/updEmpTag',
    method: 'post',
    data
  })
}
// 绑定员工
export function bindEmployeeNos(data) {
  return request({
    url: '/spWorkWechat/strategyBind/bindEmployeeNos',
    method: 'post',
    data
  })
}
// 保存打标签方案名称
export function storeTagPlanName(data) {
  return request({
    url: '/spWorkWechat/spCorp/storeTagPlanName',
    method: 'post',
    data
  })
}
// 标签计划列表
export function plansList(params) {
  return request({
    url: '/spWorkWechat/spCorp/plansList',
    method: 'get',
    params
  })
}
// 标签方案员工列表
export function usersForInitTag(params) {
  return request({
    url: '/spWorkWechat/spCorp/usersForInitTag',
    method: 'get',
    params
  })
}
// 保存打标签方案详情
export function planDetail(params) {
  return request({
    url: '/spWorkWechat/spCorp/planDetail',
    method: 'get',
    params
  })
}
// 保存打标签方案
export function storeTagPlan(data) {
  return request({
    url: '/spWorkWechat/spCorp/storeTagPlan',
    method: 'post',
    data
  })
}
// 拉群设置列表
export function groupRuleList(params) {
  return request({
    url: '/spWorkWechat/strategyBind/groupRuleList',
    method: 'get',
    params
  })
}
// 绑定拉群设置
export function bindGroupRule(data) {
  return request({
    url: '/spWorkWechat/strategyBind/bindGroupRule',
    method: 'post',
    data
  })
}

// 预计推送人数
export function expectedMassCustomersxin(params) {
  return request({
    url: '/spWorkWechat/strategy/expectedMassCustomers',
    method: 'get',
    params
  })
}
// 消息阈值踢人
export function setMessageNumber(data) {
  return request({
    url: '/spWorkWechat/groupChatSet/setMessageNumber',
    method: 'post',
    data
  })
}
// 填写登录验证码
export function loginVerifyCode(data) {
  return request({
    url: '/spWorkWechat/upTool/loginVerifyCode',
    method: 'post',
    data
  })
}
// 继承账号
export function transferAccount(data) {
  return request({
    url: '/spWorkWechat/accountAccess/transferAccount',
    method: 'post',
    data
  })
}
// 填写登录验证码
export function totalStatistics(params) {
  return request({
    url: '/spWorkWechat/spCorp/totalStatistics',
    method: 'get',
    params
  })
}

// 填写登录验证码
export function spCorpchart(params) {
  return request({
    url: '/spWorkWechat/spCorp/chart',
    method: 'get',
    params
  })
}

// 补充群id
export function supplementUpChatroomId(data) {
  return request({
    url: '/spWorkWechat/groupChatSet/supplementUpChatroomId',
    method: 'post',
    data
  })
}
//
// 补充群id
export function supplementUpChatroomIdQwb(data) {
  return request({
    url: '/spWorkWechat/groupChatSet/supplementUpChatroomIdQwb',
    method: 'post',
    data
  })
}
// 初始化删除标签
export function delRemarkInit(data) {
  return request({
    url: '/spWorkWechat/spCorp/delRemarkInit',
    method: 'post',
    data
  })
}
// 运营策略暂停
export function suspendStrategy(data) {
  return request({
    url: '/spWorkWechat/strategy/suspendStrategy',
    method: 'post',
    data
  })
}
// 企微策略员工编号名称筛选员工
export function getEmployees(data = {}) {
  return request({
    url: 'spWorkWechat/strategyBind/getEmployees',
    method: 'post',
    data
  })
}
// 复用绑定员工
export function strategyreuseBind(data = {}) {
  return request({
    url: '/spWorkWechat/strategy/reuseBind',
    method: 'post',
    data
  })
}
// 导出报表
export function spChatGroupexport(data = {}) {
  return request({
    url: '/spWorkWechat/spChatGroup/export',
    method: 'post',
    data
  })
}
// 开始建新群
export function startbuild(data) {
  return request({
    url: '/spWorkWechat/spCorp/startJob',
    method: 'post',
    data
  })
}
// 企微发送结果
export function strategyscriptPushRecord(params) {
  return request({
    url: '/spWorkWechat/strategy/scriptPushRecord',
    method: 'get',
    params
  })
}
// 爱奇艺推广链接
export function iqiyipromotionlinklist(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link/list',
    method: 'get',
    params
  })
}
// 创建爱奇艺推广链接
export function iqiyipromotionlinkcreate(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/create',
    method: 'post',
    data
  })
}
// 删除爱奇艺推广链接
export function iqiyipromotionlinkdel(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/del',
    method: 'post',
    data
  })
}
// 修改爱奇艺推广链接
export function iqiyipromotionlinkedit(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/update',
    method: 'post',
    data
  })
}
// 重新邀请发言人入群
export function reinvite(data = {}) {
  return request({
    url: '/spWorkWechat/wwScriptJob/batchReInvite',
    method: 'post',
    data
  })
}
// 拉取单向好友
export function spCorpgetOneWayFriends(data = {}) {
  return request({
    url: '/spWorkWechat/upTool/pullAloneCustomers',
    method: 'post',
    data
  })
}
// 爱奇艺推广链接
export function iqiyipromotionlinklistone(params) {
  return request({
    url: '/ad1/iqiyi/static_html_link/list',
    method: 'get',
    params
  })
}
// 创建爱奇艺推广链接
export function iqiyipromotionlinkcreateone(data) {
  return request({
    url: '/ad1/iqiyi/static_html_link/create',
    method: 'post',
    data
  })
}
// 删除爱奇艺推广链接
export function iqiyipromotionlinkdelone(data) {
  return request({
    url: '/ad1/iqiyi/static_html_link/del',
    method: 'post',
    data
  })
}
// 修改爱奇艺推广链接
export function iqiyipromotionlinkeditone(data) {
  return request({
    url: '/ad1/iqiyi/static_html_link/update',
    method: 'post',
    data
  })
}
// 详情
export function iqiyipromotionlinkcreatedetails(params) {
  return request({
    url: '/ad1/iqiyi/static_html_link/detail',
    method: 'get',
    params
  })
}
// 上传完告知后端
export function iqiyipromotionlikuploadyun(data) {
  return request({
    url: '/ad1/iqiyi/static_html_link/upload_yun',
    method: 'post',
    data
  })
}
// 上传返回html结构
export function iqiyipromotionlikkwqewq(data) {
  return request({
    url: '/officialAccount/importWxArticle',
    method: 'post',
    timeout: 20 * 1000,
    data
  })
}
// 是否默认
export function iqiyipromotionlichangedefault(data) {
  return request({
    url: '/ad1/iqiyi/static_html_link/change_default',
    method: 'post',
    data
  })
}
// 消息列表
export function delayedMsgList(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link/list_delayed_msg',
    method: 'get',
    params
  })
}
// 添加消息
export function createDelayedMsg(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/create_delayed_msg',
    method: 'post',
    data
  })
}

// 修改消息
export function updDelayedMsg(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/update_delayed_msg',
    method: 'post',
    data
  })
}

// 删除消息
export function delDelayedMsg(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/del_delayed_msg',
    method: 'post',
    data
  })
}// 删除消息
export function changeSwitchMsg(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/stop_delayed_msg',
    method: 'post',
    data
  })
}
// 爱奇艺推广链接用户
export function iqiyilinkuserlist(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link/link_user_list',
    method: 'get',
    params
  })
}
// 爱奇艺推广链接巨量回传类型
export function oceanengineeventtype(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link/ocean_engine_event_type',
    method: 'get',
    params
  })
}
// 爱奇艺推广链接巨量回传
export function oceanengineback(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/ocean_engine_back',
    method: 'post',
    data
  })
}
// 爱奇艺推广链接巨量回传记录
export function oceanenginerecord(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link/ocean_engine_record',
    method: 'get',
    params
  })
}
// 升级群ID
export function chatIdUpgrade(data) {
  return request({
    url: '/spWorkWechat/spCorp/chatIdUpgrade',
    method: 'post',
    data
  })
}

// 好友监测
export function getEmployeeFriendList(params) {
  return request({
    url: '/spWorkWechat/spCorp/userDetection/list',
    method: 'get',
    params
  })
}
// 创建好友检测
export function addEmployeeFriend(data) {
  return request({
    url: '/spWorkWechat/spCorp/userDetection/createCorpUserDetection',
    method: 'post',
    data
  })
}
// 更新好友检测
export function updEmployeeFriend(data) {
  return request({
    url: '/spWorkWechat/spCorp/userDetection/editCorpUserDetection',
    method: 'post',
    data
  })
}

// 删除好友检测
export function delEmployeeFriend(data) {
  return request({
    url: '/spWorkWechat/spCorp/userDetection/del',
    method: 'post',
    data
  })
}

// 好友检测更换状态
export function employeeFriendChange(data) {
  return request({
    url: '/spWorkWechat/spCorp/userDetection/disableStatus',
    method: 'post',
    data
  })
}
// 清除邀请游标
export function clearCursor(data) {
  return request({
    url: '/spWorkWechat/groupChatSet/clearCursor',
    method: 'post',
    data
  })
}
// 代理配置列表
export function proxyConfigList(params) {
  return request({
    url: '/spWorkWechat/proxy/config/index',
    method: 'get',
    params
  })
}
// 代理配置创建
export function proxyConfigCreate(data) {
  return request({
    url: '/spWorkWechat/proxy/config/create',
    method: 'post',
    data
  })
}
// 代理配置更新
export function proxyConfigUpd(data) {
  return request({
    url: '/spWorkWechat/proxy/config/update',
    method: 'post',
    data
  })
}
// 代理配置删除
export function proxyConfigDel(data) {
  return request({
    url: '/spWorkWechat/proxy/config/destroy',
    method: 'post',
    data
  })
}
// 代理配置导入
export function proxyConfigImport(data) {
  return request({
    url: '/spWorkWechat/proxy/config/import',
    method: 'post',
    isUpload: true,
    data
  })
}
// 查看绑定列表
export function proxyRecordList(params) {
  return request({
    url: '/spWorkWechat/proxy/record/index',
    method: 'get',
    params
  })
}
// 由创客户端绑定代理IP
export function bindProxy(data) {
  return request({
    url: '/spWorkWechat/upTool/client/bindProxy',
    method: 'post',
    data
  })
}
// 代理配置导入
export function proxyConfigImportrrr(data) {
  return request({
    url: '/spWorkWechat/proxy/record/importBind',
    method: 'post',
    isUpload: true,
    data
  })
}
// 设置待发送由创消息目标员工
export function messagecorrelationEmployee(data) {
  return request({
    url: '/spWorkWechat/h5/message/correlationEmployee',
    method: 'post',
    data
  })
}
// 待发素材列表
export function strategymaterialTaskindex(params) {
  return request({
    url: '/spWorkWechat/strategy/materialTask/index',
    method: 'get',
    params
  })
}
// 待发素材创建
export function rwematerialTaskcreate(data) {
  return request({
    url: '/spWorkWechat/strategy/materialTask/create',
    method: 'post',
    data
  })
}
// 待发素材更新
export function rwematerialTaskupdate(data) {
  return request({
    url: '/spWorkWechat/strategy/materialTask/update',
    method: 'post',
    data
  })
}

// 获取数据源列表
// app_id?: string;  查询参数
// page?: string;
// pageSize?: string;
export function adDataSource(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link/ad_data_source',
    method: 'get',
    params
  })
}

// 更新update_secret_key
// {"account_id":"55576998","user_action_set_id":1217787681,"secret_key":"1233"}
export function updateSecretKey(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/update_secret_key',
    method: 'post',
    data
  })
}

// 获取数据源列表
// app_id?: string;  查询参数
// page?: string;
// pageSize?: string;
export function syncData(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link/sync_ad_data_source',
    method: 'get',
    params
  })
}

// 更新数据源状态
// {"account_id":"55576998","user_action_set_id":1217787681,"hk_status":2}
export function updateHkStatus(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/update_hk_status',
    method: 'post',
    data
  })
}

// 更新数据源默认状态
// {"account_id":"55576998","user_action_set_id":1217787681,"hk_default":2}
export function updateHkDefault(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/update_hk_default',
    method: 'post',
    data
  })
}
// 待发素材列表
export function msgtemplatelist(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link/msg_template/list',
    method: 'get',
    params
  })
}
// 创建模板
export function msgtemplatecreate(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/msg_template/create',
    method: 'post',
    data
  })
}
// 修改模板
export function msgtemplateupdate(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/msg_template/update',
    method: 'post',
    data
  })
}
// 模板详情
export function msgtemplatedetail(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link/msg_template/detail',
    method: 'get',
    params
  })
}
// 删除模板
export function msgtemplatedelete(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/msg_template/delete',
    method: 'post',
    data
  })
}
// 客户端导出
export function clientexport(params) {
  return request({
    url: '/spWorkWechat/upTool/client/export',
    method: 'get',
    params
  })
}

export function batchStopAutomatic(data) {
  return request({
    url: '/spWorkWechat/groupChatSet/batchStopAutomatic',
    method: 'post',
    data
  })
}

// 创建推送名片任务
export function createPushCardTask(data) {
  return request({
    url: '/spWorkWechat/upTool/sendBusinessCard',
    method: 'post',
    data
  })
}

// 设置接粉号
export function setReceiveEmployee(data) {
  return request({
    url: '/spWorkWechat/upTool/setAcceptEmployee',
    method: 'post',
    data
  })
}

// 设置消息间隔（秒，min ~ max）
export function setSpokesfrequency(data) {
  return request({
    url: '/spWorkWechat/upTool/setSpokesFrequency',
    method: 'post',
    data
  })
}

// 设置内部群机器人 webhook
export function setChatRobotWebhook(data) {
  return request({
    url: '/spWorkWechat/spCorp/setChatRobotWebhook',
    method: 'post',
    data
  })
}

// 获取粉丝数
export function fansCount(params) {
  return request({
    url: '/spWorkWechat/upTool/fansCountForYc',
    method: 'get',
    params
  })
}

// 快速拉群
export function quickPullGroup(data) {
  return request({
    url: '/spWorkWechat/groupChatSet/fastCreateChat',
    method: 'post',
    data
  })
}

// 拉取外部构建群
export function pullQwbChat(data) {
  return request({
    url: '/spWorkWechat/groupChatSet/pullQwbChat',
    method: 'post',
    data
  })
}

